<template>
  <v-sheet>
    <headline-bar>
      <template v-slot:prepend-btn>
        <v-btn icon @click.stop="dismissSideSheet">
          <v-icon>{{
            sideSheetIsOn && $vuetify.breakpoint.xs ? icons.back : icons.close
          }}</v-icon>
        </v-btn>
      </template>

      Account info
    </headline-bar>

    <v-form ref="form" v-model="valid" lazy-validation class="pa-6 flex-grow-1">
      <!-- Username -->
      <v-text-field
        label="Username"
        placeholder=""
        filled
        color="secondary"
        :value="'JonSnow'"
        disabled
      ></v-text-field>

      <!-- Email address -->
      <v-text-field
        v-model="user.emailAddress"
        :rules="emailRules"
        required
        label="Email address"
        placeholder=""
        filled
        clearable
        clear-icon="mdi-close-circle"
        color="secondary"
        autofocus
      ></v-text-field>

      <!-- SUBMIT BTN -->
      <v-btn
        :light="$vuetify.theme.dark"
        :dark="!$vuetify.theme.dark"
        class="float-right"
        @click="accountChange"
      >
        Submit
      </v-btn>
    </v-form>
  </v-sheet>
</template>

<script>
export default {
  data() {
    return {
      user: {
        emailAddress: "johnsnow123@gmail.com",
      },

      valid: true,
      emailRules: [
        (emailValue) => !!emailValue || "E-mail is required",
        (emailValue) => /.+@.+\..+/.test(emailValue) || "E-mail must be valid",
      ],
    };
  },

  computed: {
    sideSheetIsOn() {
      return this.$store.getters["SideSheet/isOn"];
    },
  },

  methods: {
    dismissSideSheet() {
      this.$store.dispatch("SideSheet/toggleSideSheet", { isOn: false });
    },

    accountChange() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("Profile/accountChange", { user: this.user });
        this.dismissSideSheet();
      }
    },
  },

  mounted() {
    this.sideSheet = this.sideSheetIsOn;
  },
};
</script>

<style lang="sass" scoped>
.v-text-field.v-text-field--enclosed .v-text-field__details
	margin-bottom: 0
</style>
